import { Route } from 'meta/routes/route'

export const Root: Route<undefined, undefined> = { path: '/', parts: [], generatePath: () => `/` }
